// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"6fb42e0c","248":"59389d3f","350":"7548883c"}[chunkId] + ".css";
};